import React, { useEffect } from 'react';
import {adqui_item} from '../../json/adquisicionesItem';
import './adquisiciones.css';

const Adquisiciones2 = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className='container container-mh'>
            <div className='row' >
                    <h3 className='title'>Criterios para el procedimiento de contratación ante la Oficialía Mayor</h3>
                    <hr className='hr-gob' />
            </div>
            <div className='row'>
                {
                    adqui_item.map((item, index) => (
                        <div key={index} className='col-md-4 col-sm-6 col-12 adqui_item'>
                            <a href={item.url} target="_blank" >{item.nombre}</a>
                            <hr class='row-separator'></hr>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default Adquisiciones2